import { useState, useMemo } from "react";
//Components
import AlertComponent from "./AlertComponent";
import PersonAutoSuggest from "./PersonAutoSuggest";
import PersonHistoryModal from "./PersonHistoryModal";
import TwentySevenButton from "./TwentySevenButton";
import { Badge, Fab, FormControl, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
//Styling
import { useStyles } from "../Styles/styles";
import Aliases from "./Aliases/Aliases";
import { filterBlankAliases } from "../utils/utils";

const PersonHistoryAlert = ({
  showNameModal,
  setShowNameModal,
  showEditModal,
  setShowEditModal,
  incidentId,
  incidentIndex,
  incidentOriId = "",
  pisId,
  pisUuid,
  pisIndex,
  person,
  addAlert,
  removeAlert,
  showHistory = true,
  showAlert = true,
  show27button = true,
  showAliases = false,
  showEditPersonNameButton = false,
  business = false,
  userRoles,
  user,
  inIncident,
  handlePersonOpening,
  handleIncidentOpening,
  handleTicketOpening,
  handleAddPersonMatchToIncidentState,
  setPausePolling,
  setPopper,
  incidentPeople = [],
  tokenDisabled,
  ...props
}) => {
  const classes = useStyles();
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [aliasModalOpen, setAliasModalOpen] = useState(false);
  const disableEditPersonName = !props?.canEdit;
  const aliasCount = useMemo(
    () => filterBlankAliases(person?.aliases)?.length || 0,
    [person?.aliases],
  );

  const handleEditPersonNameClick = event => {
    event.stopPropagation();
    if (disableEditPersonName) {
      return;
    }
    setShowEditModal(true);
  };

  return (
    <div className={classes.flexRow}>
      <PersonAutoSuggest
        pis={props?.pis}
        business={business}
        showNameModal={showNameModal}
        setShowNameModal={setShowNameModal}
        showEditModal={showEditModal}
        setShowEditModal={setShowEditModal}
        formControlStyle={classes.textfieldMarginAndFlexEnd}
        modalStyle={classes.modal}
        modalInputStyle={classes.modalInput}
        paperStyle={classes.paper}
        pisIndex={pisIndex}
        person={person}
        pisId={pisId}
        pisUuid={pisUuid}
        incidentId={incidentId}
        incidentIndex={incidentIndex}
        inIncident={inIncident}
        userRoles={userRoles}
        setPausePolling={setPausePolling}
        incidentPeople={incidentPeople}
        personNameEditOnly={showEditPersonNameButton}
        confirmPersonNameEdit={showEditPersonNameButton}
        openEditModalOnNameClick={!showEditPersonNameButton}
        {...props}
      />
      {/* Extract this to another component when the person history is added */}
      {showHistory && (
        <FormControl
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          className={classes.formControl}
        >
          {showEditPersonNameButton && (
            <Tooltip title={"Edit Person Name"}>
              <Fab
                aria-label="Edit Person Name"
                data-cy={"edit-person-name-button-" + person?.id}
                className={classes.fabButton}
                size="small"
                style={{ backgroundColor: "#195d1c" }}
                onClick={handleEditPersonNameClick}
                disabled={disableEditPersonName}
              >
                <EditIcon fontSize="small" />
              </Fab>
            </Tooltip>
          )}
          {showAliases && (
            <Tooltip title={"Person Aliases"}>
              <Badge
                badgeContent={aliasCount}
                color="primary"
                overlap="circular"
              >
                <Fab
                  data-cy={"alias-button-" + person?.id}
                  className={classes.fabButton}
                  size="small"
                  style={{ backgroundColor: "#611e24" }}
                  onClick={() => setAliasModalOpen(true)}
                >
                  A
                </Fab>
              </Badge>
            </Tooltip>
          )}
          <Tooltip title={"Person History"}>
            <Fab
              data-cy={"person-history-button-" + person?.id}
              className={classes.fabButton}
              style={{ backgroundColor: "#611e24" }}
              onClick={() => setShowHistoryModal(true)}
            >
              H
            </Fab>
          </Tooltip>
          <PersonHistoryModal
            modalOpen={showHistoryModal}
            setModalOpen={setShowHistoryModal}
            person={person}
            userRoles={userRoles}
            handleIncidentOpening={handleIncidentOpening}
            handleTicketOpening={handleTicketOpening}
            handlePersonOpening={handlePersonOpening}
            incidentId={incidentId}
            handleAddPersonMatchToIncidentState={
              handleAddPersonMatchToIncidentState
            }
            {...props}
          />
          {showAliases && (
            <Aliases
              modalOpen={aliasModalOpen}
              setModalOpen={setAliasModalOpen}
              aliases={person?.aliases}
              owner={person}
              pisId={pisId}
              incidentId={incidentId}
              inIncident={inIncident}
              handlePersonOpening={handlePersonOpening}
              setPausePolling={setPausePolling}
            />
          )}
          {show27button && (
            <TwentySevenButton
              person={person}
              user={user}
              incidentId={incidentId}
              setPopper={setPopper}
              tokenDisabled={tokenDisabled}
              incidentOriId={incidentOriId}
            />
          )}
        </FormControl>
      )}
      {showAlert && (
        <AlertComponent
          parentObj={person}
          accessor={"validPersonAlerts"}
          type={"person"}
          updateHandler={addAlert}
          deleteHandler={removeAlert}
          userRoles={userRoles}
          canEdit={inIncident ? props?.canEdit : true}
          incidentId={incidentId}
          {...props}
        />
      )}
    </div>
  );
};

export default PersonHistoryAlert;
